module.exports = __webpack_public_path__ + "static/media/daosquare__logo.4949f575.png";